import BasePrevenApiClient from './baseApi'

/**
 * Handles the custom dashboards module operations: dashboards, their
 * widgets, the catalog of queryable data sources and widget query
 * execution (both saved widgets and unsaved builder previews).
 */
class CustomDashboardApi extends BasePrevenApiClient {
  /**
   * Returns a shared api instance
   *
   * @returns {CustomDashboardApi} Api shared instance
   */
  static get shared() {
    return super.shared
  }

  _path(suffix) {
    return this._getFullPath(`/custom-dashboards/api${suffix}`)
  }

  getDataSources(token) {
    return this._get(this._path('/data-sources'), { authToken: token }).then(
      ({ data }) => data.data
    )
  }

  listDashboards(token) {
    return this._get(this._path('/dashboard'), { authToken: token }).then(
      ({ data }) => data.data
    )
  }

  getDashboard(token, id) {
    return this._get(this._path(`/dashboard/${id}`), {
      authToken: token,
    }).then(({ data }) => data)
  }

  createDashboard(token, data) {
    return this._post(this._path('/dashboard'), data, {
      authToken: token,
    }).then(({ data }) => data)
  }

  updateDashboard(token, id, data) {
    return this._put(this._path(`/dashboard/${id}`), data, {
      authToken: token,
    }).then(({ data }) => data)
  }

  deleteDashboard(token, id) {
    return this._delete(this._path(`/dashboard/${id}`), { authToken: token })
  }

  createWidget(token, dashboardId, data) {
    return this._post(this._path(`/dashboard/${dashboardId}/widget`), data, {
      authToken: token,
    }).then(({ data }) => data)
  }

  updateWidget(token, widgetId, data) {
    return this._put(this._path(`/widget/${widgetId}`), data, {
      authToken: token,
    }).then(({ data }) => data)
  }

  deleteWidget(token, widgetId) {
    return this._delete(this._path(`/widget/${widgetId}`), {
      authToken: token,
    })
  }

  reorderWidgets(token, dashboardId, order) {
    return this._post(
      this._path(`/dashboard/${dashboardId}/widget/reorder`),
      { order },
      { authToken: token }
    ).then(({ data }) => data)
  }

  getWidgetData(token, widgetId) {
    return this._get(this._path(`/widget/${widgetId}/data`), {
      authToken: token,
    }).then(({ data }) => data)
  }

  previewWidget(token, config) {
    return this._post(this._path('/widget/preview'), config, {
      authToken: token,
    }).then(({ data }) => data)
  }
}

export default CustomDashboardApi
